import { render, staticRenderFns } from "./AlertaVigenciaPlan.vue?vue&type=template&id=2fa07126"
import script from "./AlertaVigenciaPlan.vue?vue&type=script&lang=js"
export * from "./AlertaVigenciaPlan.vue?vue&type=script&lang=js"
import style0 from "./AlertaVigenciaPlan.vue?vue&type=style&index=0&id=2fa07126&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports